import React from "react";
import { IoMdShare } from "react-icons/io";
import { toast } from "react-toastify";
import StarRating from "./StarRating";

const PropertyHeading = ({
  rating,
  title,
  tagline,
  price,
  location,
  onSelectRoom,
  address,
  reviewStats,
}) => {

  const handleShare = async () => {
    const shareUrl = window.location.href;

    const shareText = `🏨 ${title}, ${location?.location_name}
⭐ ${rating} Stars
📍 ${address}

Found this great hotel for stay!
Check availability & book here 👇`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: shareText,
          url: shareUrl,
        });
      } catch (error) {
        console.log("Share cancelled");
      }
    }
    else {
      navigator.clipboard.writeText(shareUrl);
      toast.success("Hotel link copied! Share it with your friends 😊");
    }
  };

  return (
    <div className="dltheadingouter">
      <div className="dltheading">
        <span className="startp">
          <StarRating value={Number(reviewStats?.avgRating ?? rating)} />
          {reviewStats?.totalReviews > 0 && (
            <span>{reviewStats.totalReviews} reviews</span>
          )}

          {/* SHARE BUTTON */}
          <span
            className="sharebtn"
            onClick={handleShare}
          >
            Share <IoMdShare size={18} />
          </span>
        </span>

        <h2>
          {title}, {location?.location_name}
        </h2>

        <p>{tagline}</p>
        <p>{address}</p>
      </div>

      <div className="dltrtbts">
        <div className="dltpriceouter">
          <span>From</span>
          <span className="price">₹ {price}</span>
          <span>/per night</span>
        </div>

        <div className="dltrtbtsinner">
          <button className="theme-btn" type="button" onClick={onSelectRoom}>
            Select Room
          </button>
        </div>
      </div>
    </div>
  );
};

export default PropertyHeading;
